import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {IntlProvider} from 'react-intl';
import {DndProvider} from 'react-dnd';
import {HTML5Backend} from 'react-dnd-html5-backend';
import App from './contents/App';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import configureStore from './stores/configure-store';
import * as serviceWorker from './serviceWorker';
import messages from './localizations';
import {buildLogger} from './lib/logHelper';
import {getLogConfig} from './lib/webserverConfigHelper';
import GlobalReduxStore from './stores/globalReduxStore';

require('./index.scss');

const NextApp = require('./contents/App').default;

const init = async () => {
  const logConfig = await getLogConfig();
  const store = configureStore(logConfig.disableStoreLogger);

  GlobalReduxStore.setStore(store);

  buildLogger(logConfig.browserLogLevel, logConfig.logLevel, logConfig.logMaxStackSize, logConfig.logKey);

  ReactDOM.render(
    <Provider store={store}>
      <DndProvider backend={HTML5Backend}>
        <IntlProvider locale="en" messages={messages.en}>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </IntlProvider>
      </DndProvider>
    </Provider>,
    document.getElementById('root'),
  );

  if (module.hot) {
    module.hot.accept('./contents/App', () => {
      ReactDOM.render(
        <Provider store={store}>
          <DndProvider backend={HTML5Backend}>
            <IntlProvider locale="en" messages={messages.en}>
              <ErrorBoundary>
                <NextApp />
              </ErrorBoundary>
            </IntlProvider>
          </DndProvider>
        </Provider>,
        document.getElementById('root'),
      );
    });
  }

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
};

init();
